















































































































import { Button, MDInput, Toggle } from "@micad/vue-components";
import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
import { LoginResponse, passwordLogin } from "@/data/repos/passwordLogin";
import router from "@/router";
import { displayRequestStatus } from "@/notifications";
import { Branding, getBrandingMetadata } from "@/data/repos/branding";
import Loading from "@/components/Loading.vue";
import { Auth } from "@micad/vue-components/src/repos/login";
import { Client } from "@/assets/js/constants";
import NotificationsPanel from "@/components/Auth/NotificationsPanel.vue";
import BrandingCard from "@/components/Auth/BrandingCard.vue";
import MobileHeader from "@/components/Auth/MobileHeader.vue";
import { Term } from "@/data/repos/termsAndConditions";
import { getKV, setKV } from "@/modules/browserLocalStorage";
import {
  getActiveNotifications,
  Notification,
} from "@/data/repos/notifications";
import { getDayEnd, SaveAuth } from "@/modules/auth";
import { CLIENT_COOKIE_NAME } from "@/interfaces/common.interfaces";
import { QAvatar, QBtn } from "quasar";
import { googleOauthRedirect, msOauthRedirect } from "@/modules/sso";
import { ssoInit } from "@/data/repos/preLogin";

const maxClientsToDisplay = 10;

export default defineComponent({
  components: {
    QAvatar,
    QBtn,
    Loading,
    MDInput,
    Toggle,
    Button,
    NotificationsPanel,
    BrandingCard,
    MobileHeader,
  },
  props: {
    clientKey: { type: String },
    userId: { type: String },
    returnUrl: { type: String },
    callbackUrl: { type: String },
  },
  setup(p) {
    const query = router.currentRoute.query;
    const pClientKey =
      !!p.clientKey && p.clientKey !== "undefined" ? p.clientKey : undefined;
    const qClientKey = query.clientKey ? String(query.clientKey) : undefined;
    const qCid = query.cid ? String(query.cid) : undefined;
    const qUserName = query.userName ? String(query.userName) : undefined;
    const qReturnUrl = query.returnUrl ? String(query.returnUrl) : undefined;
    const qCallbackUrl = query.callbackUrl
      ? String(query.callbackUrl)
      : undefined;
    const nonce = ref<string | undefined>("");
    ssoInit().then((resp) => (nonce.value = resp.payload?.parameters.nonce));
    const state = reactive({
      app: ((query.app || "") as string) || undefined,
      clientKeyLocal: pClientKey || qClientKey || qCid || undefined,
      clientKeyHint: getKV(CLIENT_COOKIE_NAME),
      userName: p.userId || qUserName || "",
      returnUrlLocal: p.returnUrl || qReturnUrl || "",
      callbackUrlLocal: p.callbackUrl || qCallbackUrl || "",
      password: "",
      toggled: false,
      serverErrorMessage: "",
      loaded: false,
      showClientSelector: false,
      clients: [] as Client[],
      notifications: [] as Notification[],
      auth: {} as LoginResponse,
      maxClientsToDisplay,
      onSubmit,
      forgottenPassword,
      termsAgreed: null as boolean | null,
      showTermsDialog: false,
      terms: [] as Term[],
      loginResponse: {} as LoginResponse,
      branding: {} as Branding,
      brandingPresent: computed<boolean>(
        (): boolean =>
          !!state.branding.text ||
          (state.branding.images && !!state.branding.images.length)
      ),
      googleOauth,
      msOauth,
    });
    function msOauth() {
      msOauthRedirect(
        state.clientKeyLocal,
        qCallbackUrl,
        qReturnUrl,
        nonce.value,
        state.app
      );
    }
    function googleOauth() {
      googleOauthRedirect(
        state.clientKeyLocal,
        qCallbackUrl,
        qReturnUrl,
        nonce.value,
        state.app
      );
    }

    function forgottenPassword() {
      router.push({
        name: "forgot-password",
        query: {
          userName: state.userName,
          clientKey: state.clientKeyLocal,
          originalUrl: window.location.href,
        },
      });
    }

    // go back to "/pre-login" if missing mandatory data
    if (!state.userName) {
      router.push({ name: "pre-login" });
      return state;
    }

    async function onSubmit(
      userName: string,
      password: string,
      toggled: boolean
    ) {
      if (toggled) {
        localStorage.setItem("savedUserName", userName);
      } else {
        localStorage.removeItem("savedUserName");
      }
      state.serverErrorMessage = "";
      const clientKey =
        String(state.clientKeyLocal ? state.clientKeyLocal : "") || undefined;
      const response = await passwordLogin(
        userName,
        password,
        undefined,
        "127.0.0.1"
      );
      SaveAuth({
        userId: response.payload?.userId,
        sessionId: response.payload?.sessionId,
        expiry: getDayEnd().toISOString(),
      } as Auth);

      if (
        response.response?.data?.errorMessage ===
          "Cannot login as historical user" ||
        response.response?.data?.errorMessage ===
          "Cannot login as historical user with email"
      ) {
        const type =
          response.response?.data?.errorMessage ===
          "Cannot login as historical user"
            ? "legacy"
            : "legacyEmail";
        await router.push({
          name: "LegacyAccount",
          query: {
            ...query,
            userName: state.userName,
            type,
          },
        });
        return;
      }
      displayRequestStatus(response, "", "Invalid username or password");
      if (response.ok && response.payload) {
        const r = response.payload;
        state.auth = r;
        if (r.clientKey) setKV(CLIENT_COOKIE_NAME, r.clientKey);
        SaveAuth({
          userId: r.userId,
          sessionId: r.sessionId,
          expiry: getDayEnd().toISOString(),
        } as Auth);
        await router.push({
          name: "chooseClient",
          query: query,
          params: {
            session: JSON.stringify(state.auth),
            clientKey: clientKey || "",
          },
        });
      }
    }

    async function retrieveNotifications() {
      const clientKey = state.clientKeyLocal || state.clientKeyHint || "";
      state.notifications =
        (await getActiveNotifications(clientKey, state.app)).payload || [];
    }

    async function retrieveBranding() {
      state.loaded = false;
      await retrieveNotifications();
      if (!state.clientKeyLocal && !state.clientKeyHint) {
        state.loaded = true;
        return;
      }
      state.branding =
        (
          await getBrandingMetadata(
            "login",
            String(state.clientKeyLocal || state.clientKeyHint),
            state.app || undefined
          )
        ).payload || ({} as Branding);
      state.loaded = true;
    }

    // check for saved userName
    const savedUserName = localStorage.getItem("savedUserName");
    if (savedUserName != null) {
      state.toggled = true;
      state.userName = savedUserName;
    }

    setTimeout(() => retrieveBranding(), 0);

    watch(
      () => state.loaded,
      () => {
        setTimeout(
          () =>
            (
              document.getElementById("password") || { focus: () => null }
            ).focus(),
          500
        );
      }
    );

    watch(
      () => state.showClientSelector,
      () => {
        setTimeout(
          () =>
            (
              document.getElementById("clientSearch") || { focus: () => null }
            ).focus(),
          500
        );
      }
    );

    return state;
  },
});
